/**
 * Hook pour le pointage (arrivée ou départ)
 */
import { clockInOut } from "@/services";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useClockInOut = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      pin,
      action,
    }: {
      pin: string;
      action: "CLOCK_IN" | "CLOCK_OUT";
    }) => {
      return {
        data: await clockInOut(pin, action),
        pin,
        action,
      };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["sessions"] });
      queryClient.invalidateQueries({ queryKey: ["late-sessions"] });
    },
    onError: (error) => {
      console.error("Erreur lors du pointage:", error);
    },
  });
};
